// Add your custom JS here.
import Glide from '@glidejs/glide';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

if(document.querySelectorAll('.hero-slider').length > 0){
var carousel = new Glide('.hero-slider', {
  type: 'carousel',
  perView: 1,
  focusAt: 'center',
  gaps: 0,

    
});
carousel.mount(); 
}

if(document.querySelectorAll('.glide').length > 0){
var carousel = new Glide('.glide', {
  type: 'carousel',
  perView: 4,
  focusAt: 'center',
  breakpoints: {
    768: {
      perView: 2
    }
  }
    
});
carousel.mount(); 
}
if(document.querySelectorAll('.blog-carousel').length > 0){
var blogCarousel = new Glide('.blog-carousel', {
  type: 'carousel',
  perView: 3,
  focusAt: 'center',
  breakpoints: {
    768: {
      perView: 2
    }
  }
    
});
blogCarousel.mount(); 
}

/*
// Cache the sections with the class 'animate'
let sections = document.querySelectorAll('.animate');
const screen = document.querySelector(".screens");
// Create the IntersectionObserver
let observer = new IntersectionObserver((entries, observer) => {
  for (let i = 0; i < entries.length; i++) {
    let entry = entries[i];
    
    // Check if the element is intersecting
    if (entry.isIntersecting) {

      // Add the 'show' class to the target
      entry.target.classList.add("show");
      screen.style.backgroundImage = entry.target.getAttribute("data-bg");
      //document.getElementByID(screen).style.opacity = 1;
      // Unobserve the target to stop observing once the animation is triggered
      observer.unobserve(entry.target);
    }
  }
}, {
  threshold: 0.1,  // Trigger when 10% of the element is visible
  rootMargin: "0px 0px -50px 0px"  // Adjust root margin for earlier/later triggering
});

// Observe each section
sections.forEach((section) => {
  observer.observe(section);
});
*/

const section = document.querySelectorAll(".animate");
const screen = document.getElementById("screens");


const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        if (entry.target.classList.contains('text-content')){
        screen.style.backgroundImage = entry.target.getAttribute("data-bg");
        }

      }
    });
  },
  {
    threshold: 0.5
  }
);

section.forEach((el, i) => {
  observer.observe(el);
});



/* NAV MENU */
// Seleziona tutti i bottoni per aprire i menu di primo e secondo livello
if (window.innerWidth <= 768) {
  

const menuButtons = document.querySelectorAll("button.menu__arrow, button.menu__sub-arrow");

menuButtons.forEach(button => {
  button.addEventListener("click", function(e) {
    console.log(menuButtons);
    // Previene la propagazione per evitare conflitti con eventuali listener annidati
    e.stopPropagation();

    // 1) Reset di tutte le frecce
    menuButtons.forEach(btn => {
      btn.style.transform = 'rotate(0deg)';
    });

    // Recupera il <li> contenitore dell'elemento cliccato e il menu associato (presumibilmente l'elemento immediatamente successivo)
    const currentLi = button.closest("li");
    const currentMenu = button.nextElementSibling;
    const isOpen = currentMenu.classList.contains("menu-opened");

    // Se il bottone appartiene al menu di PRIMO LIVELLO
    if (button.classList.contains("menu__arrow")) {
      // Rimuove la classe "menu-opened" da ogni menu aperto (sia di primo che di secondo livello)
      document.querySelectorAll(".menu-opened").forEach(menu => {
        menu.classList.remove("menu-opened");
      });
      // Se il menu cliccato era chiuso, lo apre (toggle)
      if (!isOpen) {
        currentMenu.classList.add("menu-opened");
        button.style.transform = 'rotate(180deg)';
      }
    } 
    // Se il bottone appartiene al menu di SECONDO LIVELLO
    else if (button.classList.contains("menu__sub-arrow")) {
      // Recupera il container (tipicamente un <ul>) degli item del secondo livello
      const parentSubUl = currentLi.parentElement;
      // Chiude solo i menu aperti negli altri <li> di questo stesso livello
      Array.from(parentSubUl.children).forEach(li => {
        if (li !== currentLi) {
          const subBtn = li.querySelector("button.menu__sub-arrow");
          if (subBtn && subBtn.nextElementSibling) {
            subBtn.nextElementSibling.classList.remove("menu-opened");
          }
        }
      });
      // Esegue il toggle: apre il menu se era chiuso, oppure lo chiude se era aperto
      if (!isOpen) {
        currentMenu.classList.add("menu-opened");
      } else {
        currentMenu.classList.remove("menu-opened");
      }
    }
  });
});
}

 
const toastLive = document.getElementById('liveToast')
  document.addEventListener('DOMContentLoaded', () => {
    const toast = new bootstrap.Toast(toastLive)
    toast.show();
  });

